import clsx from 'clsx';
import React from 'react';
import { ButtonWithIcon } from 'src/components/Buttons';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { ChevronLeftIcon } from 'src/svgs/Viagogo';

import * as styles from './MobileHeaderBar.css';

export const MobileHeaderBar = ({
  title,
  actions,
  className,
  onBack,
}: {
  title: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
  onBack: () => void;
}) => {
  return (
    <Stack
      width="full"
      alignItems="center"
      justifyContent="spaceBetween"
      className={clsx(styles.headerBar, className)}
    >
      <Stack
        direction="row"
        alignItems="center"
        gap="m"
        className={styles.headerBarTitle}
      >
        <ButtonWithIcon
          variant="textPlain"
          shape="rect"
          style={{ height: '36px', width: '36px' }}
          icon={
            <ChevronLeftIcon
              fill={vars.color.textSecondary}
              size={vars.iconSize.s}
              withHoverEffect
            />
          }
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onBack();
          }}
        />
        {title}
      </Stack>
      {actions}
    </Stack>
  );
};
